/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)



// import Rails from 'rails-ujs';
// Rails.start();

import Chartkick from 'chartkick'
import Chart from 'chart.js'

import '../src/application.scss'
import "tabler-react/dist/Tabler.css"
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker';

$(function () {
  $.fn.datepicker.defaults.format = 'yyyy-mm-dd';
  $.fn.datepicker.defaults.autoclose = true;

  $('.input-daterange').each(function() {
  	$(this).datepicker({
      inputs: $(this).find('.range-datepicker')
    });
  });

  $(document).on('click','.shortlinks-link',function(e) {
    var target = $(this).data('target');
    var startDate = $(this).data('start');
    var endDate = $(this).data('end');
    $(target+'_start input').val(startDate);
    $(target+'_end input').val(endDate);
    e.preventDefault();
    return false;
  });

  // fix autofocus within modals
  $('.modal').on('shown.bs.modal', function(e) {
    var autofocusTarget = $(e.relatedTarget).data('autofocus-target') || '[autofocus]';
    $(this).find(autofocusTarget).focus();
  });
});

window.Chartkick = Chartkick
Chartkick.addAdapter(Chart)
Chartkick.options = {
  library: {animation: {easing: 'easeOutQuart'}},
}

import '../src/flashmessages';
import '../src/clickablecards';
import '../src/donut-statistics';
import '../src/errormessages';
